import { render, staticRenderFns } from "./IdeaChecklist.vue?vue&type=template&id=61becd84&"
import script from "./IdeaChecklist.vue?vue&type=script&lang=js&"
export * from "./IdeaChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports